module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"modals":{"confirm":{"ok":"Ok","cancel":"Cancel","yes":"Yes","no":"No"}}},"es":{"modals":{"confirm":{"ok":"Ok","cancel":"Cancelar","yes":"Sí","no":"No"}}},"fr":{"modals":{"confirm":{"ok":"Ok","cancel":"Annuler","yes":"Oui","no":"Non"}}},"pt":{"modals":{"confirm":{"ok":"Ok","cancel":"Cancelar","yes":"Sim","no":"Não"}}},"de":{"modals":{"confirm":{"ok":"Ok","cancel":"Abbrechen","yes":"Ja","no":"Nein"}}},"nl":{"modals":{"confirm":{"ok":"Ok","cancel":"Annuleren","yes":"Ja","no":"Geen"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@intlify/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/modules/modals/components/ModalConfirm.vue
// module id = kMSE
// module chunks = 10